import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';

const GrupoValidacionesCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="show">
      <TextInput source="descripcion" validate={[required()]} label="resources.grupo-validaciones.fields.descripcion" />
    </SimpleForm>
  </Create>
);

export default GrupoValidacionesCreate;
